import React, { useState, useEffect, useReducer } from "react";
import { useFetch } from "../../../Utils/useFetch";
import {
  FETCH_ALL_TRANSACTION_API,
  FETCH_ALL_DEPT_API,
  FETCH_ALL_STOCK_API,
  FETCH_RECEIVED_STOCK_QUANTITY_PER_PRODUCT_TYPE_API
} from "../../../Constants/Apis";
import EcomAggTable from "../../elements/Tables/EcomAggTable/EcomAggTable";
import EcomAggCategoryTable from "../../elements/Tables/EcomAggCategoryTable/EcomAggCategoryTable";
import EcomAggCategoryMappingTable from "../../elements/Tables/EcomAggCategoryMappingTable/EcomAggCategoryMappingTable";
import EcomProductTypeSummaryTable from "../../elements/Tables/EcomProductTypeSummaryTable/EcomProductTypeSummaryTable";
import { reducer } from "../../../Utils/CommonUtils";
import {
  Card,
  Row,
  Col,
  Statistic,
  Select,
  DatePicker,
  Spin,
  Typography,
  Divider,
  Table,
  message,
} from "antd";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  LineChart,
  Line,
} from "recharts";
import {
  AggEcomTransaction,
  AggEcomTransactionCategory,
  AggEcomTransactionProductType,
} from "../../../Services/TransactionService";
import dayjs from "dayjs";
import EcomAggProductTypeTable from "../../elements/Tables/EcomAggProductTypeTable/EcomAggProductTypeTable";

const { Title, Text } = Typography;
const { Option } = Select;
const { RangePicker } = DatePicker;

const EcomDashboardPage = ({ history, userData }) => {
  const initialState = {
    searchKeyword: "",
    departmentFilter: "",
    dateRange: [],
    filteredInfo: {},
    sorter: {},
  };

  const [state, dispatch] = useReducer(reducer, initialState);
  const [loading, setLoading] = useState(false);
  const [salesData, setSalesData] = useState([]);
  const [timeRange, setTimeRange] = useState("week");
  const [dateRange, setDateRange] = useState([
    dayjs().subtract(7, "day"),
    dayjs(),
  ]);
  // Added: Ecom Agg state
  const [aggEcomData, setAggEcomData] = useState([]);
  const [aggEcomDataCategory, setAggEcomDataCategory] = useState([]);
  const [aggEcomDataProductType, setAggEcomDataProductType] = useState([]);
  const [stockQuantityData, setStockQuantityData] = useState([]);
  const [receivedStockData, setReceivedStockData] = useState([]);

  const [loadingAgg, setLoadingAgg] = useState(false);

  const categoryMapping = {
    "BTS": [
      "BTS BOYS K",
      "BTS BOYS T",
      "BTS GIRLS K",
      "BTS GIRLS T",
      "BTS MEN",
      "BTS WOMEN",
      "BTS BOYS K BERHADIAH",
      "BTS BOYS T BERHADIAH"
    ],
    "non BTS": [
      "CASUAL KIDS MALE",
      "CASUAL KIDS FEMALE",
      "CASUAL BOYS",
      "CASUAL GIRLS",
      "PHYLON MEN",
      "PHYLON MEN - MICKELSON",
      "CASUAL MEN",
      "CASUAL WOMEN",
      "OUTDOOR MEN R",
      "BADMINTON MEN R",
      "FUTSAL BOYS R",
      "FUTSAL MEN R",
      "SOCCER MEN R"
    ],
    "Lifestyle": [
      "LIFESTYLE MEN",
      "LIFESTYLE WOMEN"
    ],
    "Basket": [
      "BASKET BOYS R",
      "BASKET MEN R",
      "BASKET WOMEN R"
    ],
    "Running": [
      "RUNNING MEN R",
      "RUNNING WOMEN R"
    ],
    "SDL": [
      "SANDAL MEN",
      "SANDAL WOMEN",
      "SANDAL GIRLS",
      "SPON GUNUNG JEPIT BOYS",
      "SPON JEPIT WOMEN",
      "PHYLON SELOP MEN",
      "SPON GUNUNG JEPIT MEN",
      "SPON GUNUNG SELOP MEN",
      "SPON GUNUNG JEPIT JEMPOL MEN",
      "SANDAL BOYS BERHADIAH"
    ]
  };

  
  // Colors for charts
  const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#8884d8"];

  const {
    fetchedData: { data: deptData = [] },
  } = useFetch(`${FETCH_ALL_DEPT_API}/active`, state);

  // Fetch AggEcomTransaction
  const fetchAggEcomTransaction = async (params = {}) => {
    setLoadingAgg(true);
    try {
      const response = await AggEcomTransaction(params);
      console.log(response);
      setAggEcomData(Array.isArray(response.data) ? response.data : []);
    } catch (e) {
      message.error("Failed to fetch Ecom data");
      setAggEcomData([]);
    }
    setLoadingAgg(false);
  };

  // Fetch AggEcomTransactionCategory
  const fetchAggEcomTransactionCategory = async (params = {}) => {
    setLoadingAgg(true);
    try {
      const response = await AggEcomTransactionCategory(params);
      console.log(response);
      setAggEcomDataCategory(Array.isArray(response.data) ? response.data : []);
    } catch (e) {
      message.error("Failed to fetch Ecom data");
      setAggEcomDataCategory([]);
    }
    setLoadingAgg(false);
  };

  // Fetch AggEcomTransactionProductType
  const fetchAggEcomTransactionProductType = async (params = {}) => {
    setLoadingAgg(true);
    try {
      const response = await AggEcomTransactionProductType(params);
      console.log(response);
      setAggEcomDataProductType(
        Array.isArray(response.data) ? response.data : []
      );
    } catch (e) {
      message.error("Failed to fetch Ecom product type data");
      setAggEcomDataProductType([]);
    }
    setLoadingAgg(false);
  };

  // Fetch Stock Quantity per Product Type
  const fetchStockQuantityData = async () => {
    try {
      const response = await fetch(FETCH_ALL_STOCK_API + "/quantity-per-product-type");
      const result = await response.json();
      if (result.success) {
        setStockQuantityData(Array.isArray(result.data) ? result.data : []);
      } else {
        message.error("Failed to fetch stock quantity data");
        setStockQuantityData([]);
      }
    } catch (e) {
      message.error("Failed to fetch stock quantity data");
      setStockQuantityData([]);
    }
  };

  // Fetch Received Stock Quantity per Product Type
  const fetchReceivedStockData = async (startDate, endDate) => {
    try {
      let url = FETCH_RECEIVED_STOCK_QUANTITY_PER_PRODUCT_TYPE_API;
      if (startDate && endDate) {
        url += `?startDate=${startDate}&endDate=${endDate}`;
      }
      
      const response = await fetch(url);
      const result = await response.json();
      if (result.success) {
        setReceivedStockData(Array.isArray(result.data) ? result.data : []);
      } else {
        message.error("Failed to fetch received stock data");
        setReceivedStockData([]);
      }
    } catch (e) {
      message.error("Failed to fetch received stock data");
      setReceivedStockData([]);
    }
  };

  // Call on mount and whenever dateRange changes
  useEffect(() => {
    const [startDate, endDate] = dateRange || [];
    fetchAggEcomTransactionCategory({
      startDate: startDate ? startDate.format("YYYY-MM-DD") : undefined,
      endDate: endDate ? endDate.format("YYYY-MM-DD") : undefined,
    });
  }, [dateRange]);

    useEffect(() => {
      const [startDate, endDate] = dateRange || [];
      fetchAggEcomTransactionProductType({
        startDate: startDate ? startDate.format("YYYY-MM-DD") : undefined,
        endDate: endDate ? endDate.format("YYYY-MM-DD") : undefined,
      });
    }, [dateRange]);

  useEffect(() => {
    const [startDate, endDate] = dateRange || [];
    fetchAggEcomTransaction({
      startDate: startDate ? startDate.format("YYYY-MM-DD") : undefined,
      endDate: endDate ? endDate.format("YYYY-MM-DD") : undefined,
    });
  }, [dateRange]);

  // Fetch stock data on component mount
  useEffect(() => {
    fetchStockQuantityData();
  }, []);

  // Fetch received stock data when date range changes
  useEffect(() => {
    const [startDate, endDate] = dateRange || [];
    fetchReceivedStockData(
      startDate ? startDate.format("YYYY-MM-DD") : undefined,
      endDate ? endDate.format("YYYY-MM-DD") : undefined
    );
  }, [dateRange]);

  const handleDateChange = async (dates) => {
    setDateRange(dates);
    // FetchAgg is handled by useEffect on dateRange
    dispatch({
      type: "dateRange",
      payload: {
        startDate: dates && dates[0] ? dates[0].format("YYYY-MM-DD") : null,
        endDate: dates && dates[1] ? dates[1].format("YYYY-MM-DD") : null,
      },
    });
    // callReFetchTransactions();
  };

  const handleTimeRangeChange = (value) => {
    setTimeRange(value);
  };

  const formatCurrency = (value) => {
    return `Rp ${value.toLocaleString("id-ID")}`;
  };

  // Prepare pie chart data for Marketplace Value distribution
  const prepareMarketplaceValuePieData = () => {
    if (!aggEcomData || aggEcomData.length === 0) return [];
    
    // Get PERIOD data (selected period)
    const periodData = aggEcomData.filter(d => d.Period === "PERIOD");
    
    return periodData
      .filter(d => d._id && d._id !== "ALL") // Exclude totals
      .map(d => ({
        name: d._id || "Unknown",
        value: d.Value || 0
      }))
      .sort((a, b) => b.value - a.value);
  };

  // Prepare pie chart data for Marketplace Quantity distribution
  const prepareMarketplaceQtyPieData = () => {
    if (!aggEcomData || aggEcomData.length === 0) return [];
    
    // Get PERIOD data (selected period)
    const periodData = aggEcomData.filter(d => d.Period === "PERIOD");
    
    return periodData
      .filter(d => d._id && d._id !== "ALL") // Exclude totals
      .map(d => ({
        name: d._id || "Unknown",
        value: d.QTY || 0
      }))
      .sort((a, b) => b.value - a.value);
  };

  // Prepare pie chart data for Category table
  const prepareCategoryPieData = () => {
    if (!aggEcomDataCategory || aggEcomDataCategory.length === 0) return [];
    
    // Sum data across all weeks for each category
    const categoryTotals = {};
    aggEcomDataCategory.forEach(d => {
      if (d._id.category) { // Exclude totals
        const categoryName = d._id.category;
        categoryTotals[categoryName] = (categoryTotals[categoryName] || 0) + (d.totalQty || 0);
      }
    });
    
    const categoryData = Object.entries(categoryTotals)
      .map(([name, value]) => ({
        name,
        value
      }))
      .sort((a, b) => b.value - a.value);
    
    // Get top 10 and group the rest as "Others"
    const top10 = categoryData.slice(0, 10);
    const others = categoryData.slice(10);
    
    if (others.length > 0) {
      const othersTotal = others.reduce((sum, item) => sum + item.value, 0);
      top10.push({
        name: "Others",
        value: othersTotal
      });
    }
    
    return top10;
  };

  // Prepare pie chart data for Product Type table
  const prepareProductTypePieData = () => {
    if (!aggEcomDataProductType || aggEcomDataProductType.length === 0) return [];
    
    // Sum data across all weeks for each product type
    const productTypeTotals = {};
    aggEcomDataProductType.forEach(d => {
      if (d._id.category) { // Exclude totals
        const productTypeName = d._id.category;
        productTypeTotals[productTypeName] = (productTypeTotals[productTypeName] || 0) + (d.totalQty || 0);
      }
    });
    
    return Object.entries(productTypeTotals)
      .map(([name, value]) => ({
        name,
        value
      }))
      .sort((a, b) => b.value - a.value);
  };

  // Prepare pie chart data for Stock Distribution
  const prepareStockDistributionPieData = () => {
    if (!stockQuantityData || stockQuantityData.length === 0) return [];
    
    // Get top 10 product types by stock quantity and group the rest as "Others"
    const sortedData = stockQuantityData
      .filter(item => item.productType && item.totalQuantity > 0)
      .sort((a, b) => b.totalQuantity - a.totalQuantity);
    
    const top10 = sortedData.slice(0, 10);
    const others = sortedData.slice(10);
    
    const result = top10.map(item => ({
      name: item.productType,
      value: item.totalQuantity
    }));
    
    if (others.length > 0) {
      const othersTotal = others.reduce((sum, item) => sum + item.totalQuantity, 0);
      result.push({
        name: "Others",
        value: othersTotal
      });
    }
    
    return result;
  };

  // Prepare pie chart data for Category Mapping Distribution
  const prepareCategoryMappingPieData = () => {
    if (!aggEcomDataCategory || aggEcomDataCategory.length === 0) return [];

    const mappingTotals = {};

    // Initialize mapping totals
    Object.keys(categoryMapping).forEach(mappingKey => {
      mappingTotals[mappingKey] = {
        totalQty: 0,
        totalValue: 0
      };
    });

    // Aggregate data by category mapping
    aggEcomDataCategory.forEach(item => {
      if (item._id && item._id.category) {
        const categoryName = item._id.category;
        
        // Find which mapping this category belongs to
        Object.entries(categoryMapping).forEach(([mappingKey, categories]) => {
          if (categories.includes(categoryName)) {
            mappingTotals[mappingKey].totalQty += item.totalQty || 0;
            mappingTotals[mappingKey].totalValue += item.totalValue || 0;
          }
        });
      }
    });

    // Convert to array format for pie chart
    return Object.entries(mappingTotals)
      .map(([mappingKey, totals]) => ({
        name: mappingKey,
        value: totals.totalQty
      }))
      .filter(item => item.value > 0)
      .sort((a, b) => b.value - a.value);
  };


  // Table columns for AggEcomTransaction
  const aggEcomColumns = [
    {
      title: "Period",
      dataIndex: "Period",
      key: "Period",
      filters: [
        { text: "PERIOD", value: "PERIOD" },
        { text: "MTD", value: "MTD" },
        { text: "YTD", value: "YTD" },
      ],
      onFilter: (value, record) => record.Period === value,
      sorter: (a, b) => a.Period.localeCompare(b.Period),
      render: (v) => <b>{v}</b>,
    },
    {
      title: "Channel",
      dataIndex: "_id",
      key: "_id",
      render: (v) => v || <span style={{ color: "#ccc" }}>ALL</span>,
    },
    {
      title: "QTY",
      dataIndex: "QTY",
      key: "QTY",
      align: "right",
      sorter: (a, b) => a.QTY - b.QTY,
      render: (v) => v?.toLocaleString("id-ID"),
    },
    {
      title: "Value",
      dataIndex: "Value",
      key: "Value",
      align: "right",
      sorter: (a, b) => a.Value - b.Value,
      render: (v) => `Rp ${v?.toLocaleString("id-ID")}`,
    },
    {
      title: "Price Point",
      dataIndex: "PricePoint",
      key: "PricePoint",
      align: "right",
      sorter: (a, b) => a.PricePoint - b.PricePoint,
      render: (v) => `Rp ${Math.round(v).toLocaleString("id-ID")}`,
    },
  ];

  // Top products table columns (from your original code, left unchanged)
  const topProductColumns = [
    {
      title: "Product",
      dataIndex: "product",
      key: "product",
    },
    {
      title: "Quantity Sold",
      dataIndex: "quantity",
      key: "quantity",
      sorter: (a, b) => a.quantity - b.quantity,
    },
    {
      title: "Sales Amount",
      dataIndex: "sales",
      key: "sales",
      render: (sales) => formatCurrency(sales),
      sorter: (a, b) => a.sales - b.sales,
      defaultSortOrder: "descend",
    },
  ];

  return (
    <div
      style={{
        width: "100%",
        padding: "20px",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        overflowX: "hidden",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "1200px",
          marginBottom: "20px",
        }}
      >
        <Title level={2}>Business Dashboard</Title>
        <Text type="secondary">
          Overview of sales performance and business insights
        </Text>

        {/* Filters */}
        <Row gutter={[16, 16]} style={{ marginTop: "20px" }}>
          <Col xs={24} sm={8}>
            <RangePicker
              style={{ width: "100%" }}
              onChange={handleDateChange}
              value={dateRange}
            />
          </Col>
          <Col xs={24} sm={8}>
            <Select
              value={timeRange}
              style={{ width: "100%" }}
              allowClear
              onChange={(value) => {
                setTimeRange(value || "");
                if (!value) {
                  handleDateChange([dayjs().subtract(7, "day"), dayjs()]);
                } else if (value === "yesterday") {
                  handleDateChange([dayjs().subtract(1, "day"), dayjs()]);
                } else if (value === "week") {
                  handleDateChange([dayjs().subtract(7, "day"), dayjs()]);
                } else if (value === "month") {
                  handleDateChange([dayjs().subtract(30, "day"), dayjs()]);
                } else if (value === "year") {
                  handleDateChange([dayjs().subtract(365, "day"), dayjs()]);
                }
              }}
            >
              <Option value="">Clear Selection</Option>
              <Option value="yesterday">Yesterday</Option>
              <Option value="week">Last Week</Option>
              <Option value="month">Last Month</Option>
              <Option value="year">Last Year</Option>
            </Select>
          </Col>
        </Row>

        {/* E-Commerce Transaction Summary Table with Pie Charts */}
        <Row gutter={[24, 24]} align="middle">
          <Col xs={24} lg={16}>
            <EcomAggTable aggEcomData={aggEcomData} />
          </Col>
          <Col xs={24} lg={8}>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
              <Card
                title="Marketplace Distribution"
                style={{
                  height: "fit-content",
                  boxShadow: "0 2px 16px rgba(0,0,0,0.06)",
                  borderRadius: 18,
                }}
              >
                <div style={{ marginBottom: '20px' }}>
                  <div style={{ textAlign: 'center', marginBottom: '10px', fontWeight: '600', fontSize: '14px' }}>
                    Value Distribution
                  </div>
                  <ResponsiveContainer width="100%" height={200}>
                    <PieChart>
                      <Pie
                        data={prepareMarketplaceValuePieData()}
                        cx="50%"
                        cy="45%"
                        labelLine={false}
                        label={false}
                        outerRadius={50}
                        fill="#8884d8"
                        dataKey="value"
                      >
                        {prepareMarketplaceValuePieData().map((entry, index) => (
                          <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                        ))}
                      </Pie>
                      <Tooltip 
                        formatter={(value, name) => [
                          `Rp ${value.toLocaleString("id-ID")}`, 
                          name
                        ]}
                        labelFormatter={(name) => `Marketplace: ${name}`}
                      />
                      <Legend 
                        verticalAlign="bottom" 
                        height={30}
                        formatter={(value) => value}
                        wrapperStyle={{ fontSize: '10px' }}
                      />
                    </PieChart>
                  </ResponsiveContainer>
                </div>
                
                <div>
                  <div style={{ textAlign: 'center', marginBottom: '10px', fontWeight: '600', fontSize: '14px' }}>
                    Quantity Distribution
                  </div>
                  <ResponsiveContainer width="100%" height={200}>
                    <PieChart>
                      <Pie
                        data={prepareMarketplaceQtyPieData()}
                        cx="50%"
                        cy="45%"
                        labelLine={false}
                        label={false}
                        outerRadius={50}
                        fill="#8884d8"
                        dataKey="value"
                      >
                        {prepareMarketplaceQtyPieData().map((entry, index) => (
                          <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                        ))}
                      </Pie>
                      <Tooltip 
                        formatter={(value, name) => [
                          value.toLocaleString("id-ID"), 
                          name
                        ]}
                        labelFormatter={(name) => `Marketplace: ${name}`}
                      />
                      <Legend 
                        verticalAlign="bottom" 
                        height={30}
                        formatter={(value) => value}
                        wrapperStyle={{ fontSize: '10px' }}
                      />
                    </PieChart>
                  </ResponsiveContainer>
                </div>
              </Card>
            </div>
          </Col>
        </Row>

        {/* Category Sales Table with Pie Chart */}
        <Row gutter={[24, 24]} align="middle">
          <Col xs={24} lg={16}>
            <EcomAggCategoryTable aggEcomDataCategory={aggEcomDataCategory} />
          </Col>
          <Col xs={24} lg={8}>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
              <Card
                title="Category Distribution (All Weeks)"
                style={{
                  height: "fit-content",
                  boxShadow: "0 2px 16px rgba(0,0,0,0.06)",
                  borderRadius: 18,
                }}
              >
                <ResponsiveContainer width="100%" height={350}>
                  <PieChart>
                    <Pie
                      data={prepareCategoryPieData()}
                      cx="50%"
                      cy="45%"
                      labelLine={false}
                      label={false}
                      outerRadius={70}
                      fill="#8884d8"
                      dataKey="value"
                    >
                      {prepareCategoryPieData().map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                      ))}
                    </Pie>
                    <Tooltip 
                      formatter={(value, name) => [
                        value.toLocaleString("id-ID"), 
                        name
                      ]}
                      labelFormatter={(name) => `Category: ${name}`}
                    />
                    <Legend 
                      verticalAlign="bottom" 
                      height={80}
                      formatter={(value) => value}
                      wrapperStyle={{ 
                        fontSize: '10px',
                        lineHeight: '14px',
                        paddingTop: '10px'
                      }}
                      iconType="circle"
                      layout="horizontal"
                    />
                  </PieChart>
                </ResponsiveContainer>
              </Card>
            </div>
          </Col>
        </Row>

        {/* Category Group Performance Table with Pie Chart */}
        <Row gutter={[24, 24]} align="middle">
          <Col xs={24} lg={16}>
            <EcomAggCategoryMappingTable 
              aggEcomDataCategory={aggEcomDataCategory}
            />
          </Col>
          <Col xs={24} lg={8}>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
              <Card
                title="Category Group Distribution"
                style={{
                  height: "fit-content",
                  boxShadow: "0 2px 16px rgba(0,0,0,0.06)",
                  borderRadius: 18,
                }}
              >
                <ResponsiveContainer width="100%" height={350}>
                  <PieChart>
                    <Pie
                      data={prepareCategoryMappingPieData()}
                      cx="50%"
                      cy="45%"
                      labelLine={false}
                      label={false}
                      outerRadius={70}
                      fill="#8884d8"
                      dataKey="value"
                    >
                      {prepareCategoryMappingPieData().map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                      ))}
                    </Pie>
                    <Tooltip 
                      formatter={(value, name) => [
                        value.toLocaleString("id-ID"), 
                        name
                      ]}
                      labelFormatter={(name) => `Category Group: ${name}`}
                    />
                    <Legend 
                      verticalAlign="bottom" 
                      height={80}
                      formatter={(value) => value}
                      wrapperStyle={{ 
                        fontSize: '10px',
                        lineHeight: '14px',
                        paddingTop: '10px'
                      }}
                      iconType="circle"
                      layout="horizontal"
                    />
                  </PieChart>
                </ResponsiveContainer>
              </Card>
            </div>
          </Col>
        </Row>

        {/* Product Type Sales Table with Pie Chart */}
        <Row gutter={[24, 24]} align="middle">
          <Col xs={24} lg={16}>
            <EcomAggProductTypeTable
              aggEcomDataProductType={aggEcomDataProductType}
            />
          </Col>
          <Col xs={24} lg={8}>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
              <Card
                title="Product Type Distribution (All Weeks)"
                style={{
                  height: "fit-content",
                  boxShadow: "0 2px 16px rgba(0,0,0,0.06)",
                  borderRadius: 18,
                }}
              >
                <ResponsiveContainer width="100%" height={300}>
                  <PieChart>
                    <Pie
                      data={prepareProductTypePieData()}
                      cx="50%"
                      cy="50%"
                      labelLine={false}
                      label={false}
                      outerRadius={80}
                      fill="#8884d8"
                      dataKey="value"
                    >
                      {prepareProductTypePieData().map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                      ))}
                    </Pie>
                    <Tooltip 
                      formatter={(value, name) => [
                        value.toLocaleString("id-ID"), 
                        name
                      ]}
                      labelFormatter={(name) => `Product Type: ${name}`}
                    />
                    <Legend 
                      verticalAlign="bottom" 
                      height={36}
                      formatter={(value) => value}
                      wrapperStyle={{ fontSize: '12px' }}
                    />
                  </PieChart>
                </ResponsiveContainer>
              </Card>
            </div>
          </Col>
        </Row>

        {/* Product Type Summary Table with Stock Distribution Pie Chart */}
        <Row gutter={[24, 24]} align="middle">
          <Col xs={24} lg={16}>
            <EcomProductTypeSummaryTable
              aggEcomDataProductType={aggEcomDataProductType}
              stockQuantityData={stockQuantityData}
              receivedStockData={receivedStockData}
              dateRange={dateRange}
            />
          </Col>
          <Col xs={24} lg={8}>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
              <Card
                title="Stock Distribution by Product Type"
                style={{
                  height: "fit-content",
                  boxShadow: "0 2px 16px rgba(0,0,0,0.06)",
                  borderRadius: 18,
                }}
              >
                <ResponsiveContainer width="100%" height={300}>
                  <PieChart>
                    <Pie
                      data={prepareStockDistributionPieData()}
                      cx="50%"
                      cy="50%"
                      labelLine={false}
                      label={false}
                      outerRadius={80}
                      fill="#8884d8"
                      dataKey="value"
                    >
                      {prepareStockDistributionPieData().map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                      ))}
                    </Pie>
                    <Tooltip 
                      formatter={(value, name) => [
                        value.toLocaleString("id-ID"), 
                        name
                      ]}
                      labelFormatter={(name) => `Product Type: ${name}`}
                    />
                    <Legend 
                      verticalAlign="bottom" 
                      height={36}
                      formatter={(value) => value}
                      wrapperStyle={{ fontSize: '12px' }}
                    />
                  </PieChart>
                </ResponsiveContainer>
              </Card>
            </div>
          </Col>
        </Row>

        {/* You can place your existing charts and top products table below here */}
      </div>
    </div>
  );
};

export default EcomDashboardPage;
